import React, { Component } from "react";
import { connect } from "react-redux";
import { Tab, Row, Col, Nav } from "react-bootstrap";
import { Link } from "@reach/router";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { ButtonSecondary } from "../../../UI/Buttons";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { translationHook } from "../../../translationHook";
import { Form, Field } from "react-final-form";
import { TextField, Switches } from "mui-rff";
import apiConfig from "../../../../apis/apiConfig";
import { getLicenseTradeNameInfo } from "../../../../apis/licenses/licenseTradeNames/getLicenseTradeNameInfo";
import { validateAgentData } from "../../../../apis/charity/agents/validateAgentData";

import {
	ButtonPrimary,
	ButtonDanger,
	ButtonInfo,
	ButtonWarning,
} from "../../../UI/Buttons";
import {
	triggerDialog,
	setLoading,
	triggerNotification,
	triggerDialogForm,
	reload,
} from "../../../../actions";

class AgentForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showForm: false,
		};
	}

	handleSubmit = async (values, form) => {
		const at = this.props.currentUser.Data.access_token,
			url = this.props.editMood
				? "/API/CHARITY/LOOKUPS/AGENTS/Update_Agent"
				: "/API/CHARITY/LOOKUPS/AGENTS/Add_Agent";
		let body = {
			...values,
			Active_Status_Id: values.Active_Status_Id ? 1 : 0,
		};

		if (this.props.editMood) {
			body = { Agent_Id: this.props.agentId, ...body };
		}

		this.props.setLoading(true, "dark");

		const response = await apiConfig
			.post(url, body, {
				headers: {
					Authorization: `Bearer ${at}`,
				},
			})
			.catch((error) => {
				return error.response;
			});

		if (response.data.Status) {
			form.restart();
		}

		if (this.props.editMood) {
			this.props.triggerDialogForm(false);
		}

		this.props.triggerNotification(true, response.data);

		this.props.setLoading(false);

		if (this.props.submitCB) {
			this.props.submitCB();
		}
	};

	render() {
		let { initValues } = this.props;

		const validate = async (values) => {
			const errors = {};
			const at = this.props.currentUser.Data.access_token;

			await validateAgentData(at, values).then((res) => {
				if (res?.Data?.Validation_Results_List?.length) {
					res?.Data?.Validation_Results_List.forEach((f) => {
						if (!f.Result) {
							errors[f.Input_Name] =
								this.props.i18n.language === "ar"
									? f.Error_AR
									: f.Error_EN;
						}
					});
				}
			});

			return errors;
		};

		return (
			<>
				{!this.props.editMood && !this.props.viewMood && (
					<div className="d-flex justify-content-between align-items-center pb-5">
						<h3>{this.props.t("agentsList")}</h3>
						<ButtonPrimary
							variant={
								!this.state.showForm ? "contained" : "outlined"
							}
							onClick={() =>
								this.setState({
									showForm: !this.state.showForm,
								})
							}
						>
							{!this.state.showForm && this.props.t("addAgent")}
							{this.state.showForm && this.props.t("cancel")}
						</ButtonPrimary>
					</div>
				)}

				<Form
					validateOnBlur={true}
					subscription={{ submitting: true }}
					onSubmit={this.handleSubmit}
					initialValues={
						initValues
							? initValues
							: {
									Active_Status_Id: 1,
									Agent_Name_AR: "",
									Agent_Name_EN: "",
									Agent_Phone: "",
							  }
					}
					validate={validate}
					render={({ handleSubmit, form, submitting }) => (
						<form
							className={`row pt-5 px-3 ${
								!this.state.showForm &&
								!this.props.editMood &&
								!this.props.viewMood
									? "d-none"
									: ""
							}`}
							onSubmit={handleSubmit}
							noValidate
						>
							<Col xs={12} md={6}>
								<TextField
									disabled
									label={this.props.t("idNo")}
									className={`read-only mb-2`}
									name="Agent_Id"
									autoComplete="off"
								/>
							</Col>

							<Col xs={12} md={6}>
								<TextField
									disabled={this.props.viewMood}
									label={this.props.t("agentPhone")}
									className={`${
										this.props.viewMood ? "read-only" : ""
									} mb-2`}
									name="Agent_Phone"
									autoComplete="off"
									showError={({
										meta: {
											submitFailed,
											invalid,
											touched,
										},
									}) => {
										return touched && invalid;
									}}
								/>
							</Col>

							<Col xs={12} md={6}>
								<TextField
									disabled={this.props.viewMood}
									label={this.props.t("nameAr")}
									className={`${
										this.props.viewMood ? "read-only" : ""
									} mb-2`}
									required={true}
									name="Agent_Name_AR"
									autoComplete="off"
									showError={({
										meta: {
											submitFailed,
											invalid,
											touched,
										},
									}) => {
										return touched && invalid;
									}}
								/>
							</Col>

							<Col xs={12} md={6}>
								<TextField
									disabled={this.props.viewMood}
									label={this.props.t("nameEn")}
									className={`${
										this.props.viewMood ? "read-only" : ""
									} mb-2`}
									required={true}
									name="Agent_Name_EN"
									autoComplete="off"
									showError={({
										meta: {
											submitFailed,
											invalid,
											touched,
										},
									}) => {
										return touched && invalid;
									}}
								/>
							</Col>

							<Col
								xs={12}
								md={2}
								className={`${
									this.props.viewMood ? "read-only" : ""
								}`}
							>
								<Switches
									disabled={this.props.viewMood}
									color="primary"
									name="Active_Status_Id"
									data={{
										label: `${this.props.t(
											"serviceStatus"
										)}`,
										defaultValue: `${this.props.t(
											"serviceStatus"
										)}`,
									}}
								/>
							</Col>

							<Col
								className="my-4 justify-content-start d-flex"
								xs={12}
							>
								{!this.props.viewMood && (
									<ButtonPrimary
										color="primary"
										variant="contained"
										disabled={
											submitting || this.props.viewMood
										}
										type="submit"
									>
										{this.props.t("save")}
									</ButtonPrimary>
								)}
							</Col>
						</form>
					)}
				/>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return { currentUser: state.currentUser };
};

export default connect(mapStateToProps, {
	triggerNotification,
	setLoading,
	triggerDialogForm,
})(translationHook(AgentForm));
